let dragOptions = function() {
	return {
		animation: 200,
		group: "description",
		disabled: false,
		ghostClass: "ghost",
	};
};
export default dragOptions;
